import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AllTableHeadersState {
  talAccountsColumns: any[];
  talContactsColumns: any[];
  walAccountsColumns: any[];
  walContactColumns: any[];
  dbSearchAccountColumns: any[];
  dbSearchContactColumns: any[];
}

const initialState: AllTableHeadersState = {
  talAccountsColumns: [],
  talContactsColumns: [],
  walAccountsColumns: [],
  walContactColumns: [],
  dbSearchAccountColumns: [],
  dbSearchContactColumns: [],
};

const allTableHeadersSlice = createSlice({
  name: 'allTableHeaders',
  initialState,
  reducers: {
    setTalAccountsAllColumns(state, action: PayloadAction<any[]>) {
      state.talAccountsColumns = action.payload;
    },
    setTalContactsAllColumns(state, action: PayloadAction<any[]>) {
      state.talContactsColumns = action.payload;
    },
    setWalAccountsAllColumns(state, action: PayloadAction<any[]>) {
      state.walAccountsColumns = action.payload;
    },
    setWalContactAllColumns(state, action: PayloadAction<any[]>) {
      state.walContactColumns = action.payload;
    },
    setDbSearchAccountAllColumns(state, action: PayloadAction<any[]>) {
      state.dbSearchAccountColumns = action.payload;
    },
    setDbSearchContactAllColumns(state, action: PayloadAction<any[]>) {
      state.dbSearchContactColumns = action.payload;
    },
    resetAllTableHeaders: () => initialState,
  },
});

export const {
  setTalAccountsAllColumns,
  setTalContactsAllColumns,
  setWalAccountsAllColumns,
  setWalContactAllColumns,
  setDbSearchAccountAllColumns,
  setDbSearchContactAllColumns,
  resetAllTableHeaders,
} = allTableHeadersSlice.actions;

export default allTableHeadersSlice.reducer;
